/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import React from "react";
import SafeLink from "components/commons/SafeLink";
import PropTypes from "prop-types";
import {
  PrimaryText,
  SecondaryText
} from "components/Text";
import styled from "styled-components";
import {colors} from "nxtconstants";


const propTypes = {
  content: PropTypes.array.isRequired
};

const defaultProps = {
  content: []
};

const Stories = ({content}) => {
  const data = [];
  content.map((datum) => {
    data.push((
      <StoryArticle
        className="story-article"
        key={datum.id}
      >
        <div className="story-thumbnail">
          <img
            alt="sory thumbnail"
            className="story-thumbnail__image"
            src={datum.imageUrl}
          />
        </div>
        <div className="story-content">
          <div className="story-title">
            <PrimaryText
              additionalStyles="text-transform: uppercase; font-weight: 700;" className="story-title__tag"
              color={colors.razzmatazz}
            >
              {datum.categories && datum.categories[0] || "investing"}
            </PrimaryText>
            <SafeLink
              className="story-title__link"
              href={`/interviews/${datum.slug}-${datum.id}`}
            >
              <SecondaryText
                additionalStyles="line-height: 3rem;"
                className="story-title__heading" color={colors.luckyPoint}
                fontSize="2.3rem"
              >
                {datum.title}
              </SecondaryText>
            </SafeLink>
          </div>
          <div className="story-footer">
            <PrimaryText
              additionalStyles="text-transform: capitalize" className="story-footer__text"
              color={colors.gray}
            >
              By {"Team Wealthy"}
            </PrimaryText>
            <hr className="story-divider" />
            <div
              style={{
                display: "flex",
                alignItems: "center"
              }}
            >
              <PrimaryText className="story-footer__text" color={colors.gray}>
                {datum.questionsAnswered || "0"} questions answered
              </PrimaryText>
            </div>
          </div>
        </div>
      </StoryArticle>
    ));
  });

  return (
    <>
      <SecondaryText
        className="story-heading"
        fontSize="1.8rem"
      >
        SUCCESS PERSONIFIED
      </SecondaryText>
      <Title>Customer Stories</Title>
      {data}
      <SafeLink className="load-more__btn" href="/stories">
        <SecondaryText
          className="load-more__text"
          color={colors.luckyPoint}
        >
        Load More
        </SecondaryText>
        <div className="arrow__right--medium-container">
          <span className="arrow__right--medium" />
        </div>
      </SafeLink>
    </>
  );
};

const StoryArticle = styled.article`
`;


const Title = styled.h2 `
  font-family: Avenir-Heavy;
  font-weight: initial;
  color: #263276;
  font-size: 3.2rem;
  line-height: calc(3.2rem * 1.5);
  margin: 1rem 0 2rem 0;
`;



Stories.propTypes = propTypes;
Stories.defaultProps = defaultProps;

export default Stories;
